export const ALERT = 'ALERT';
export const CLOSE_ALERT = 'CLOSE_ALERT';
